// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"header-module--sticky-wrapper--1wtIl","isSticky":"header-module--is-sticky--VkInE","menuContainer":"header-module--menu-container--3BddV"};